module.exports = __webpack_public_path__ + "static/img/01.11d074d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/03/01.jpg
// module id = iCvH
// module chunks = 0